import React, { Component } from 'react';
import dynamic from 'next/dynamic';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { Card } from 'tmt-ui-kit';

import Link from '~/components/Link/Link';
// import SeeMoreCard from '~/components/Card/SeeMoreCard';

import config from '~/config';

import { actions as tripActions } from '~/redux/reducers/trip';
import { actions as popupActions } from '~/redux/reducers/popup';
import { actions as sessionActions } from '~/redux/reducers/session';
import { actions as wishlistActions } from '~/redux/reducers/wishlist';
import { actions as appActions } from '~/redux/reducers/app';
import { isDusitApp, getCookie } from '~/utils/helpers';
import { triggerAddToCart } from '~/utils/data-layer';
import { createBookLink } from '~/utils/payment';
import getCurrentCountrySite from '~/utils/region-site-config';

moment.tz.setDefault('Asia/Bangkok');

const SeeMoreCard = dynamic(() => import(/* webpackChunkName: "Card.SeeMoreCard.components" */'./SeeMoreCard'), { loading: () => null });

const brisbaneList = [
  'Brisbane',
  'Gold Coast',
  'Tamborine Mountain',
  'Noosa North Shore',
  'Byron Bay',
  'Beechmont',
];

const enhance = connect(
  ({ session, info, app, wishlist, availability }) => ({
    isLoggedIn: session.isLoggedIn,
    sessionData: session.data,
    rates: info.exchangeRates,
    omitBookingFee: true,
    isMobile: app.isMobile,
    isWishlisted: wishlist.wishlistObj.isWishlisted,
    availability,
  }),
  {
    ...wishlistActions,
    openSignup: sessionActions.openSignup,
    setLoginSignupCallback: sessionActions.setLoginSignupCallback,
    openVideo: tripActions.openVideo,
    openTourCategory: popupActions.openTourCategory,
    logRequest: tripActions.logRequest,
    globalLoad: appActions.loading,
  }
);

class FourThirdCard extends Component {
  static propTypes = {
    isMobile: PropTypes.bool,
    data: PropTypes.object,
    sessionData: PropTypes.object,
    // omitBookingFee: PropTypes.bool
    isLoggedIn: PropTypes.bool,
    isWishlisted: PropTypes.object,
    setWishlistButton: PropTypes.func,
    addWishlist: PropTypes.func,
    removeWishlist: PropTypes.func,
    loadWishlists: PropTypes.func,
    rates: PropTypes.object,
    seeMore: PropTypes.string,
    setLoginSignupCallback: PropTypes.func,
    openSignup: PropTypes.func,
    openVideo: PropTypes.func,
    openTourCategory: PropTypes.func,
    hideStar: PropTypes.bool,
    displayType: PropTypes.string,
    alignment: PropTypes.string,
    ranking: PropTypes.number
  };

  shouldComponentUpdate(nextProps) {
    if (nextProps.data && this.props.data && nextProps.data._id !== this.props.data._id) {
      return true;
    }
    if (nextProps.sessionData.currency !== this.props.sessionData.currency) {
      return true;
    }
    if (nextProps.sessionData.quantity !== this.props.sessionData.quantity) {
      return true;
    }
    if (this.props.data && this.props.data._id) {
      const dataId = this.props.data._id;
      if (!this.props.isWishlisted[dataId] && !nextProps.isWishlisted[dataId]) {
        return false;
      }
      if (!this.props.isWishlisted[dataId] && nextProps.isWishlisted[dataId] && nextProps.isWishlisted[dataId].state) {
        return true;
      }
      if (this.props.isWishlisted[dataId] && nextProps.isWishlisted[dataId] && this.props.isWishlisted[dataId].state === nextProps.isWishlisted[dataId].state) {
        return false;
      }
    }
    return false;
  }

  onOpenVideo = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const url = `https://www.youtube.com/embed/${this.props.data.video_url}?autoplay=1`;
    this.props.openVideo(url);
  }

  onClick = (event) => {
    if (this.props.data.product_type === 'trip' && this.props.data.trip_type === 'joined' && !getCookie('joinTourInformed')) {
      const target = (this.props.isMobile || isDusitApp()) ? '_self' : '_blank';
      const { link, query } = this.getLink();
      this.props.openTourCategory(true, link, target, null, query);
      event.preventDefault();
      event.stopPropagation();
      return false;
    }
    return true;
  }

  getLink = () => {
    const { data } = this.props;
    const obj = {
      link: data.slug ? `/trip/${data.slug}` : '/',
    };
    return obj;
  }

  activeWishlist = (active) => {
    const { data: trip } = this.props;
    this.props.openSignup(false);
    if (active) {
      this.props.setWishlistButton(trip._id, true);
      this.props.removeWishlist(trip._id)
        .then(() => this.props.loadWishlists());
    } else {
      this.props.setWishlistButton(trip._id, false);
      this.props.addWishlist(trip._id)
        .then(() => this.props.loadWishlists());
    }
  }

  handleClickWishlist = (event, active) => {
    event.preventDefault();
    event.stopPropagation();
    if (this.props.isLoggedIn) {
      this.activeWishlist(active);
    } else {
      this.props.openSignup();
      // this.props.openLoginSignup();
      this.props.setLoginSignupCallback(() => this.activeWishlist(active));
    }
  }

  handleClickBook = (event, requestType, device, link, quantity) => {
    const { data: trip } = this.props;
    if (event) {
      triggerAddToCart(trip);
      // dataLayer().push({
      //   event: 'Dynamic Remarketing - Click Book or Message',
      //   dynamic_remarketing_trip_id: trip._id,
      //   fbads_event: 'AddToCart',
      //   gads_event: 'add_to_cart',
      //   gads_params: [{
      //     id: trip._id,
      //     google_business_vertical: 'custom',
      //   }],
      //   dynx_itemid: trip._id,
      //   dynx_pagetype: eventMapping.add_to_cart,
      // });
      this.props.logRequest({
        tripId: trip._id,
        quantity,
        multiTierQuantity: [],
        requestType,
        device,
      });
      if (trip.product_type === 'trip' && trip.trip_type === 'joined' && !getCookie('joinTourInformed')) {
        this.props.openTourCategory(true, link, '_self', trip.destination_location);
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
      this.props.globalLoad();
    }
    return true;
  }

  render() {
    const { isMobile, data, sessionData, rates, seeMore, isWishlisted, hideStar, displayType, alignment, ranking, availability } = this.props;
    let wishlisted;
    let isWishListed;
    let reviewCount;
    let wo;
    let count;
    let rating;
    if (data) {
      reviewCount = data.review_count || 0;
      wo = data.travelers_without_review || 0;
      count = reviewCount + wo;
      if (data.is_master_trip || (data.user_id && data.user_id.is_takemetour_agent)) {
        rating = data.rating || 0;
      } else {
        rating = (data.user_id && data.user_id.rating && data.user_id.rating.average_rating) || 0;
      }
      wishlisted = isWishlisted[data._id] || { state: false, loading: false };
      isWishListed = wishlisted.state !== wishlisted.loading;
    }
    if (seeMore) {
      return <SeeMoreCard seeMore={seeMore} />;
    }
    const { quantity, currency, childQuantity } = sessionData;
    const { link, query } = this.getLink();
    const isLinkNewTab = !(isMobile || isDusitApp());
    const { starting_time: startingTime, duration, ...restData } = data;
    const isInBrisbane = brisbaneList.includes(data.destination_location);
    const type = alignment === 'vertical' ? 'article' : '';
    const fixPath = config.baseURL[getCurrentCountrySite().toLowerCase()];
    const { acceptSwap } = availability;
    let { selectedDate } = availability;
    if (selectedDate.length === 0) selectedDate = sessionData.date;
    const bookLink = createBookLink(
      fixPath,
      'book',
      data,
      selectedDate,
      { quantity, childQuantity },
      { acceptSwap },
      []
    );
    return (
      <Link
        to={link}
        className="link"
        target={isLinkNewTab ? '_blank' : '_self'}
        query={query || null}
        {...isLinkNewTab ? { rel: 'noopener noreferrer' } : {}}
      >
        <Card.TripCard
          displayType={displayType}
          data={isInBrisbane ? restData : data}
          count={count}
          rating={rating}
          quantity={quantity}
          rates={rates}
          currency={currency}
          isWishlisted={isWishListed}
          onClickWishlist={(e) => this.handleClickWishlist(e, wishlisted.state !== wishlisted.loading)}
          onClickBook={(e) => this.handleClickBook(e, 'book', 'desktop', bookLink, quantity)}
          onClickVideo={this.onOpenVideo}
          bookLink={bookLink}
          isMasterTrip={data.is_master_trip}
          hideStar={hideStar}
          type={type}
          ranking={ranking}
        />
      </Link>
    );
  }
}

export default enhance(FourThirdCard);
